module.exports = __webpack_public_path__ + "static/media/background1.27da3181.jpg";